<amer-footer *ngIf="slots">
  <ng-container FooterSlot>
    <ng-container *ngFor="let component of slots?.FooterSlot">
      <ng-container [amwayRenderOutlet]="component"></ng-container>
    </ng-container>
  </ng-container>
</amer-footer>
